"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _TextArea = _interopRequireDefault(require("./TextArea"));

exports.default = _TextArea.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/addons/TextArea/index.js
// module id = 546
// module chunks = 0